/**
 * Cuts a list into consecutive slices of `size` items, in order; the last slice
 * holds the remainder. Slice k is always items[k * size, (k + 1) * size), so
 * appending to the list never moves an item into another full slice.
 */
export const chunk = <T>(items: readonly T[], size: number): T[][] => {
  if (!Number.isInteger(size) || size < 1) {
    throw new RangeError(`chunk size must be a positive integer, received ${size}`);
  }
  const slices: T[][] = [];
  for (let start = 0; start < items.length; start += size) {
    slices.push(items.slice(start, start + size));
  }
  return slices;
};
